import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { LANGUAGE_KEYS } from 'src/app/_constants/app.constants';
import { ObjectLiteral } from 'src/app/_models/user';
import { FlightService } from 'src/app/_services/api/flight/flight.service';
import { LanguageService } from 'src/app/_services/api/language/language.service';
import { LoggerService } from 'src/app/_services/ui/logger/logger.service';

@Component({
  selector: 'ua-flight-card-container',
  templateUrl: './flight-card-container.component.html',
  styleUrls: ['./flight-card-container.component.scss']
})
export class FlightCardContainerComponent implements OnInit, OnDestroy {

  @Input() title: string = LANGUAGE_KEYS.FLIGHT_CARD_CONTAINER.TITLE;

  activeFlightSegment = null
  flightDetails = null;
  showMoreInformation: boolean = false;
  hideMoreInformation: boolean = false;
  pageConstants: ObjectLiteral = {};
  languageSubscription: Subscription;

  constructor(
    private flightService: FlightService,
    private languageService: LanguageService,
    private logger: LoggerService
  ) {
    this.languageSubscription = this.languageService.languageChanges.subscribe(() => {
    this.pageConstants = this.languageService.constants?.flightDetails || {};
    });
  }



  ngOnInit(): void {
    this.flightDetails = this.flightService.flightDetails;
    this.activeFlightSegment = this.flightService.activeSegment;
    this.hideMoreInformation = this.flightDetails?.segments?.length == 1;
  }

  toggleMoreInfo(){
    this.logger.debug("FlightCardContainerComponent.toggleMoreInfo", this);
    this.showMoreInformation = !this.showMoreInformation;
  }

  ngOnDestroy(): void {
    this.logger.debug("FlightCardContainerComponent.ngOnDestroy", this);
    this.languageSubscription && this.languageSubscription.unsubscribe();
  }
}
